export default [
	{
		path: '/task/list',
		name: 'taskList',
		component: () => import('@/views/task/list.vue'),
		meta:{keepAlive:true,title:'任务日历'}
	}
]